<template>
  <div>
    <div class="ml-0 mt-4">
      <div v-if="currentItems.length > 0" class="row mr-0 ml-0">
        <div class="col-md-4 p-0 my-auto" v-for="(item, index) in currentItems">
          <div :class="((index === 1) ? 'mx-2' : '') + ((index === 0) ? 'mr-2' : '') + ((index === 2) ? 'ml-2' : '')">
            <div class="d-flex align-content-center">
              <img class="rounded imgcarroussel m-auto" :src="item.fileUrl" alt="Image preview"/>
            </div>
          </div>
        </div>
      </div>
      <div v-if="items.length > 3" class="d-flex align-items-center">
        <div class="row mx-auto">
          <div class="mr-3" @click="clickPreviousButton()">
            <b-icon-chevron-left size="64"/>
          </div>
          {{ this.items.length + ' ' + $t("venteLot.Photos") }}
          <div class="ml-3" @click="clickNextButton()">
            <b-icon-chevron-right size="64"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {

  name: 'B122Carroussel',

  props: {
    items: {
      type: Array,
      default: {}
    }
  },

  components: {},

  data() {
    return {
      currentItems: [],
      startIndex: -1,
      endIndex: 1
    }
  },

  computed: {},

  mounted() {
    this.clickNextButton()
  },

  methods: {

    clickNextButton() {
      if (this.items.length > 0 && this.endIndex < this.items.length) {
        this.endIndex++
        this.startIndex++
        this.currentItems = []
        for (let i = this.startIndex; i <= this.endIndex; i++) {
          this.currentItems.push(this.items.at(i))
        }
      }
    },

    clickPreviousButton() {
        if (this.items.length > 0 && this.startIndex > 0) {
          this.startIndex--
          this.endIndex--
          this.currentItems = []
          for (let i = this.startIndex; i <= this.endIndex; i++) {
            this.currentItems.push(this.items.at(i))
          }
        }
    }
  }
}
</script>

<style scoped>

.imgcarroussel {
  max-width: 100%;
  max-height: 300px;
  width: auto;
  height: auto;
  min-height: 150px;
  object-fit: cover;
}

</style>



// WEBPACK FOOTER //
// src/views/venteLot/B122Carroussel.vue